<template>
  <div>
    <v-dialog :value="true" scrollable persistent :max-width="maxWidth">
      <v-card>
        <v-card-title class="primary modal-title py-0">
          <span>Adicionar Contrarrazão</span>
          <v-spacer/>
          <v-btn icon @click="fecharModal">
            <v-icon size="20" color="white">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="overflow-x: hidden">
          <v-layout row wrap>
            <v-flex xs3 sm3 d-flex>
              <campo-apresentacao
                  v-if="dadosLicitacao.numeroEdital"
                  labelPadrao="Edital"
                  :text="dadosLicitacao.numeroEdital"
              />
            </v-flex>
            <v-flex xs3 sm3 d-flex>
              <campo-apresentacao
                  v-if="dadosLicitacao.numProcesso"
                  labelPadrao="Nº Licitação"
                  :text="dadosLicitacao.numProcesso"
              />
            </v-flex>
            <v-flex xs3 sm3 d-flex>
              <campo-apresentacao
                  v-if="propostaResumo.fornecedor.razaoSocialFornecedor"
                  labelPadrao="Razão Social"
                  :text="propostaResumo.fornecedor.razaoSocialFornecedor"
              />
            </v-flex>
            <v-flex xs3 sm3 d-flex>
              <campo-apresentacao
                  v-if="propostaResumo.fornecedor.cnpjFornecedor"
                  labelPadrao="CNPJ"
                  :text="propostaResumo.fornecedor.cnpjFornecedor"
              />
            </v-flex>
            <v-flex xs3 sm3 d-flex>
              <campo-apresentacao v-if="contrarrazaoRascunho" labelPadrao="Data/Hora Criação" :text="contrarrazaoRascunho.dataCriacao | dataHumanizada"/>
            </v-flex>
            <v-flex xs3 sm3 d-flex>
              <campo-apresentacao v-if="contrarrazaoRascunho" labelPadrao="Situação" :text="getSituacao"/>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs8 sm8 d-flex>
              <div class="az-text">
                <label class="label">Objeto</label>
                <div v-if="dadosLicitacao.objeto">
                  <v-tooltip v-if="dadosLicitacao.objeto.length > 148" top nudge-top="15" max-width="600">
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <p class="mb-0 text-truncate-multiline texto">{{ dadosLicitacao.objeto.substring(0, 148)+'...' }}</p>
                      </div>
                    </template>
                    <p class="mb-0 text-truncate-multiline" >{{ dadosLicitacao.objeto }}</p>
                  </v-tooltip>
                  <div v-else>
                    <p class="texto">{{ dadosLicitacao.objeto }}</p>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex>
              <p class="text-campo" style="margin-bottom: 5px">Tipos</p>
              <v-chip v-for="lote in recurso.lotes">{{lote.descricao}}</v-chip>
            </v-flex>
          </v-layout>
          <p class="text-campo pb-1" style="margin-top: 4px">
            Conteúdo Recurso
          </p>
          <div class="pb-2">{{recurso.conteudo}}</div>
          <div>
            <p class="text-campo pb-1" style="margin-bottom: 4px">Anexos</p>
            <a v-for="anexo in recurso.anexos" :href="criarLinkDownloadTemporario(anexo.uri)" class="link-sem-decoracao">
              <v-chip class="mx-1" small>
                {{anexo.nome}}<v-icon class="ml-1">get_app</v-icon>
              </v-chip>
            </a>
            <p>
            <span v-if="!recurso.anexos || recurso.anexos.length < 1">
              Nenhum anexo inserido para este recurso
            </span>
            </p>
          </div>
          <p class="text-campo" style="margin-top: 4px">Conteúdo Contrarrazão
          <span class="ml-1 red--text">*</span>
          <span class="ml-1 red--text" v-if="limiteTextoAtingido">Limite máximo de caracteres atingido!</span></p>
          <v-textarea rows="2" auto-grow class="textarea-conteudo-recurso required-field" placeholder="Informe o conteúdo..." v-model="dadosGeraisContrarrazao.conteudoContrarrazao" v-on:keyup="contarTamanhoTexto" counter/>
          <div>
            <p class="text-campo" style="margin-bottom: 4px">Anexos</p>
            <licitacao-recurso-contrarrazao-anexo style="margin-top: -25px" :dadosRecursoContrarrazao="dadosGeraisContrarrazao"/>
          </div>
        </v-card-text>
        <div class="az-actions-form actions-modal">
          <button class="action-secundary-button" @click="fecharModal">Cancelar</button>
          <div v-if="dadosGeraisContrarrazao.conteudoContrarrazao && dadosGeraisContrarrazao.conteudoContrarrazao.trim()">
            <button class="action-primary-button" @click.prevent="salvarContrarrazao">
              Salvar Contrarrazão
            </button>
            <button class="action-primary-button" @click.prevent="confirmarResposta">
              Enviar Contrarrazão
            </button>
          </div>
          <div v-else>
            <v-tooltip top nudge-top="10" max-width="250">
              <template v-slot:activator="{ on }">
                <button v-on="on" class="action-primary-button-disabled btn-disabled">Salvar Contrarrazão</button>
                <button v-on="on" class="action-primary-button-disabled btn-disabled">Enviar Contrarrazão</button>
              </template>
              É necessário que o conteúdo esteja preenchidos para continuar.
            </v-tooltip>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <modal-confirmar-etapa-anexo
        v-model="modalConfirmarEnvio"
        :title="'Confirmar Envio'"
        :max-width="'450'"
        :text="mensagemConfirmacao"
        second-text="Esta ação NÃO PODERÁ ser desfeita!"
        @fecharModalConfirm="naoContinuarSemAnexo"
        @cancelarAcao="naoContinuarSemAnexo"
        @confirmarAcao="enviarContrarrazao"
    />
  </div>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import {actionTypes} from '@/commons/constants'
import CampoApresentacao from '@/commons/components/campos/campo-apresentacao'
import ModalConfirmarEtapaAnexo from '@/commons/components/ModalConfirmarEtapaAnexo'
import BotaoAnexo from '@/commons/components/botoes/BotaoAnexo'
import LicitacaoEsclarecimentoAnexo from '../../../commons/LicitacaoEsclarecimentoAnexo'
import LicitacaoRecursoAnexo
  from "@/views/licitacao/detalhe/orgao/recursocontrarrazao/LicitacaoRecursoContrarrazaoAnexo";
import LicitacaoRecursoContrarrazaoAnexo
  from "@/views/licitacao/detalhe/orgao/recursocontrarrazao/LicitacaoRecursoContrarrazaoAnexo";

export default {
  name: 'ModalInserirContrarrazao',
  components: {
    LicitacaoRecursoContrarrazaoAnexo, LicitacaoRecursoAnexo, BotaoAnexo,
    LicitacaoEsclarecimentoAnexo, ModalConfirmarEtapaAnexo, CampoApresentacao
  },
  props: {
    dadosLicitacao: {
      type: Object,
      default: null
    },
    maxWidth: {
      type: String,
      default: '800'
    },
    recurso:{
      type: Object,
      default: null
    },
    contrarrazaoRascunho: {
      type: Object,
      default: null
    },
  },
  mounted() {
    this.isContrarrazaoRascunho()
  },
  data() {
    return {
      limiteTextoAtingido: false,
      maxTextArea: 1000,
      totalRemainCount: 1000,
      modalConfirmarEnvio: false,
      dadosGeraisContrarrazao: {
        conteudoContrarrazao: null,
        anexos: null,
      },
      repository: 'repo1:licitacao',
    }
  },
  computed:{
    ...mapState(['propostaResumo']),
    nenhumAnexoInserido(){
      return !this.dadosGeraisContrarrazao.anexos || !this.dadosGeraisContrarrazao.anexos.length > 0
    },
    mensagemConfirmacao(){
      if(this.nenhumAnexoInserido) {
        return 'Atenção, nenhum anexo foi inserido, deseja continuar?'
      }else{
        return 'Atenção, você está enviando uma contrarrazão. Deseja continuar?'
      }
    },
    getSituacao() {
      if (!this.contrarrazaoRascunho.enviado) {
        return 'Rascunho'
      }
      if (this.contrarrazaoRascunho.respondido) {
        return 'Respondido'
      }
      return 'Aguardando Resposta'
    }
  },
  methods: {
    ...mapActions([actionTypes.INSERIR_CONTRARRAZAO]),
    fecharModal() {
      if(this.modalConfirmarEnvio){
        this.modalConfirmarEnvio = false
      }
      this.removerUploadedFiles()
      this.$emit('fecharModal')
    },
    removerUploadedFiles(){
      try {
        this.loki.uploadedFiles.shift()
      }catch (e) {
        e()
      }
    },
    naoContinuarSemAnexo(){
      this.modalConfirmarEnvio = false
    },
    async confirmarResposta() {
      this.modalConfirmarEnvio = true
    },
    enviarContrarrazao(){
      const payload = {
        recursoId: this.recurso.id,
        lotes: this.recurso.lotes,
        ...this.dadosGeraisContrarrazao
      }
      this.$emit('enviarContrarrazao', this.contrarrazaoRascunho, payload)
      this.habilitarLoadingGlobal()
    },
    salvarContrarrazao(){
      const payload = {
        recursoId: this.recurso.id,
        lotes: this.recurso.lotes,
        ...this.dadosGeraisContrarrazao
      }
      if (this.contrarrazaoRascunho){
        this.$emit('editarContrarrazao', this.contrarrazaoRascunho.id, payload)
      } else{
        this.$emit('inserirContrarrazao', payload)
      }
      this.habilitarLoadingGlobal()
    },
    contarTamanhoTexto(){
      this.totalRemainCount = this.maxTextArea - this.dadosGeraisContrarrazao.conteudoContrarrazao.length;

      this.limiteTextoAtingido = this.totalRemainCount < 0;
      if(this.limiteTextoAtingido) this.dadosGeraisContrarrazao.conteudoContrarrazao = this.dadosGeraisContrarrazao.conteudoContrarrazao.slice(0, this.totalRemainCount)
    },
    isContrarrazaoRascunho(){
      if (this.contrarrazaoRascunho) {
        if(this.contrarrazaoRascunho.conteudo) this.dadosGeraisContrarrazao.conteudoContrarrazao = this.contrarrazaoRascunho.conteudo
        if(!this.contrarrazaoRascunho.anexos.isEmpty) this.dadosGeraisContrarrazao.anexos = this.contrarrazaoRascunho.anexos
      }
    }
  }
}
</script>

<style lang="stylus">

.max-percent
  max-width 90%

.tabulacao-content
  margin-left 10px

.modal-title
  margin: 0
  padding: 10px 20px
  font-size: 18px !important
  color: white

.actions-modal
  border-top solid thin rgba(0, 0, 0, .12)
  padding-top 10px
  margin-top 0

&-conteudo
  min-height 350px

.container-header-text
  display flex
  flex-direction row
  justify-content center
  align-items center

.text-campo
  margin 0
  font-size 14px
  font-weight bold
  color #3A6861 !important

.textarea-conteudo-recurso
  padding-top 0 !important

  textarea
    padding 5px !important
    color #777 !important

  .v-input__slot
    border 1px solid #CCCCCC
    border-radius 5px

.select-analise
  margin 0 !important
  padding-top 0 !important
  .v-select__selections
    color #777 !important

.label
  font-size 14px
  font-weight bold
  color #3A6861 !important

.texto
  font-size 14px
  color #777 !important

.v-menu__content.theme--light.v-menu__content--fixed.menuable__content__active
    max-height 232px!important;
</style>